export const TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY = 'TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY';
export type TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY = typeof TOGGLE_NETWORK_LOADING_SPINNER_VISIBILITY;



// WEBPACK FOOTER //
// ./src/store/LoadingSpinner/constants.ts